module.exports = __webpack_public_path__ + "img/hover-iocn0.751373f7.svg";